/* global axios */
import ApiClient from './ApiClient';

class ScheduledDraftsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  getDraftsUrl(conversationId) {
    return `${this.url}/${conversationId}/scheduled_drafts`;
  }

  getAll(conversationId, { page = 1, status = 'all', label = null, perPage = 15 } = {}) {
    const params = { page, status, per_page: perPage };
    if (label && label !== 'all') {
      params.label = label;
    }
    return axios.get(this.getDraftsUrl(conversationId), { params });
  }

  getLabels(conversationId) {
    return axios.get(`${this.getDraftsUrl(conversationId)}/labels`);
  }

  get(conversationId, draftId) {
    return axios.get(`${this.getDraftsUrl(conversationId)}/${draftId}`);
  }

  update(conversationId, draftId, data) {
    // Check if data contains attachments or removed attachments - if so, use FormData
    const hasAttachments = data.attachments && data.attachments.length > 0;
    const hasRemovedAttachments = data.removed_attachment_ids && data.removed_attachment_ids.length > 0;
    
    if (hasAttachments || hasRemovedAttachments) {
      console.log('API: Attachments or removed attachments detected, using FormData', {
        attachments: data.attachments,
        removed: data.removed_attachment_ids
      });
      const formData = new FormData();
      
      // Add non-file fields
      if (data.message_content) {
        formData.append('draft[message_content]', data.message_content);
      }
      if (data.email_subject) {
        formData.append('draft[email_subject]', data.email_subject);
      }
      if (data.scheduled_at) {
        formData.append('draft[scheduled_at]', data.scheduled_at);
      }
      
      // Add attachment files
      if (hasAttachments) {
        data.attachments.forEach((file, index) => {
          console.log(`API: Appending attachment ${index}:`, file.name, file.size, file.type);
          formData.append('draft[attachments][]', file);
        });
      }
      
      // Add removed attachment IDs
      if (hasRemovedAttachments) {
        data.removed_attachment_ids.forEach(id => {
          formData.append('draft[removed_attachment_ids][]', id);
        });
      }
      
      // Log FormData contents
      console.log('API: FormData entries:');
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
      
      return axios.patch(`${this.getDraftsUrl(conversationId)}/${draftId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    
    console.log('API: No attachments or removed attachments, using JSON');
    // No attachments or removed attachments - use regular JSON
    return axios.patch(`${this.getDraftsUrl(conversationId)}/${draftId}`, {
      draft: data,
    });
  }

  approve(conversationId, draftId) {
    return axios.post(`${this.getDraftsUrl(conversationId)}/${draftId}/approve`);
  }

  regenerate(conversationId, draftId, prompt = '') {
    let normalizedPrompt = '';
    if (typeof prompt === 'string') {
      normalizedPrompt = prompt;
    } else if (prompt && typeof prompt === 'object') {
      normalizedPrompt =
        prompt.additional_prompt || prompt.query || prompt.text || '';
    }
    return axios.post(
      `${this.getDraftsUrl(conversationId)}/${draftId}/regenerate`,
      { prompt: normalizedPrompt }
    );
  }

  delete(conversationId, draftId) {
    return axios.delete(`${this.getDraftsUrl(conversationId)}/${draftId}`);
  }
}

export default new ScheduledDraftsAPI();

